import "./App.css";
import { Navigate, Routes, Route, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";

import Header from "./components/header/Header";
import Facebookgroups from "./pages/facebook/facebookgroups/Facebookgroups";
import Facebookposts from "./pages/facebook/facebookposts/Facebookposts";
import Facebookaccounts from "./pages/facebook/facebookaccounts/Facebookaccounts";
import Facebookmessages from "./pages/facebook/facebookmessages/Facebookmessages";
import SearchFbGroups from "./pages/facebook/searchfbgroups/SearchFbGroups";
import FacebookLogs from "./pages/facebook/facebooklogs/FacebookLogs";
import Home from "./pages/home/Home";
import OwnerLinks from "./pages/ownerlinks/OwnerLinks";
import Calculation from "./pages/calculation/Calculation";
import AgentsList from "./pages/agentslist/AgentsList";
import Aiprompts from "./pages/aiprompts/Aiprompts";
import Craigslist from "./pages/craigslist/Craigslist";
import Duval from "./pages/duval/Duval";
import MapSheets from "./pages/mapsheets/MapSheets";
import HomeAddressSheet from "./pages/homeaddresssheets/HomeAddressSheet";
import Spintext from "./pages/spintext/Spintext";
import FacebookImport from "./pages/facebook/facebookimport/FacebookImport";
import Login from "./pages/auth/Login";

// Stats 
import Stats from "./pages/stats/Stats";
import LeadsStat from "./pages/leads/LeadsStat"

// Property Search
import PropertySearch from "./pages/propertysearch/PropertySearch";

// Deal Machine Leads
import AddedLeads from "./pages/leads/dealmachine-leads/AddedLeads";
import NotAddedLeads from "./pages/leads/dealmachine-leads/NotAddedLeads";
// import NotAddedLeadsS from "./pages/leads/dealmachine-leads/NotAddedLeadsS";
import NotAddedLeadsM from "./pages/leads/dealmachine-leads/NotAddedLeadsM";
import NotAddedLeadsB from "./pages/leads/dealmachine-leads/NotAddedLeadsB";
import NotAddedLeadsG from "./pages/leads/dealmachine-leads/NotAddedLeadsG";
import NotAddedLeadsOther from "./pages/leads/dealmachine-leads/NotAddedLeadsOther";

// Found Leads from Source ispeed, realestatebees, motivated sellers 
import FoundLeads from "./pages/leads/source-found-leads/FoundLeads";

// Not Found / Not Found 2 from Source ispeed, realestatebees, motivated sellers 
// import NotFoundS from "./pages/leads/source-not-found-leads/NotFoundS";
import NotFoundM from "./pages/leads/source-not-found-leads/NotFoundM";
import NotFoundB from "./pages/leads/source-not-found-leads/NotFoundB";
// import NotFoundS2 from "./pages/leads/source-not-found-leads/NotFoundS2";
import NotFoundM2 from "./pages/leads/source-not-found-leads/NotFoundM2";
import NotFoundB2 from "./pages/leads/source-not-found-leads/NotFoundB2";

// Routes
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import ScrollTop from "./components/ScrollTop";

import TransferHistory from "./pages/transferHistory/TransferHistory";
import Test from "./pages/Test";
import CallLogBoard from "./pages/callLogBoard/CallLogBoard";
import NotFoundPage from "./components/NotFoundPage";
import Referrals from "./pages/referrals/Referrals2";
// import AgentSearch from "./pages/referrals/AgentSearch";
// import AddAgentForm from "./pages/referrals/AddAgentForm";
import Marketplace from "./pages/marketplace/Marketplace";
import NotificationsPage from "./pages/notifications/NotificationsPage";
// import LeadsS from "./pages/leads/LeadsS";
import NotAddedLeadsD from "./pages/leads/dealmachine-leads/NotAddedLeadsD";
import DuvalNew from "./pages/leads/dealmachine-leads/DuvalNew";
import ZillowProperty from "./pages/zillow/ZillowProperty";
import WrongPhones from "./pages/leads/dealmachine-leads/WrongPhones";
import Compairables from "./pages/leads/dealmachine-leads/Compairables";
// import MailingDetails from "./pages/leads/dealmachine-leads/MailingDetails";
import FlippedProperties from "./pages/leads/dealmachine-leads/FlippedProperties";
import CallsDashboard from "./pages/callsDashboard";
import AddressOwnerGroups from "./pages/addressgroups/AddressOwnerGroups";
import FormFlowRoutes from "./pages/formflow/FormFlowRoutes";
import CreativeFinanceCalculator from "./pages/calculators/CreativeFinanceCalculator";
import NovationInstantOfferCalculator from "./pages/calculators/NovationInstantOfferCalculator";
import CashOfferCalculator from "./pages/calculators/CashOfferCalculator";
import AddressOwnerGroupsV2 from "./pages/addressgroups/AddressOwnerGroupsV2";
import StaffUsers from "./pages/staffUsers";
import ClaimedLeads from "./pages/claimedLeads";
import ClaimLead from "./pages/claim";
import LeadsTrackingDashboard from "./pages/leadsTracking";
import NotFoundG from "./pages/leads/source-not-found-leads/NotFoundG";
import NotFoundG2 from "./pages/leads/source-not-found-leads/NotFoundG2";
import NotFoundT from "./pages/leads/source-not-found-leads/NotFoundT";
import NotFoundT2 from "./pages/leads/source-not-found-leads/NotFoundT2";
import NotAddedLeadsT from "./pages/leads/dealmachine-leads/NotAddedLeadsT";
import Stats2 from "./pages/stats/Stats2";
// import VoicemailDashboard from "./pages/voicemails/VoicemailDashboard";
// import VoicemailDropDashboard from "./pages/voicemails/VoicemailDropDashboard";
// import ReferralLeads from "./pages/referralLeads/ReferralLeads";
// import Document from "./pages/document/Document";
// import Document2 from "./pages/document/Document2";
// import Testing from "./pages/document/Testing";
// Layouts
const LegacySignRedirect = () => {
  const { token } = useParams();
  return <Navigate to={`/formflow/sign/${token}`} replace />;
};

const LegacyCompletedRedirect = () => {
  const { token } = useParams();
  return <Navigate to={`/formflow/completed/${token}`} replace />;
};

const NoHeaderLayout = ({ children }) => <>{children}</>;
const HeaderLayout = ({ children }) => (
  <>
    <Header />
    {children}
  </>
);

function App() {
  return (
    // <Router>
    <div className="App">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop />

      <Routes>
        {/* Public */}
        <Route path="/test" element={<HeaderLayout> <ScrollTop /><Test /></HeaderLayout>} />
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<NoHeaderLayout><Login /></NoHeaderLayout>} />
        </Route>

        <Route >
          <Route path="/zillow-property/:address" element={<ZillowProperty />} />
          <Route path="/zillow-property" element={<ZillowProperty />} />
        </Route>
        <Route path="/addr" element={<NoHeaderLayout><AddressOwnerGroups /></NoHeaderLayout>} />
        <Route path="/v2-addr" element={<NoHeaderLayout><AddressOwnerGroupsV2 /></NoHeaderLayout>} />
        <Route path="/creative-finance-calculator" element={<HeaderLayout><CreativeFinanceCalculator /></HeaderLayout>} />
        <Route path="/novation-instant-offer-calculator" element={<HeaderLayout><NovationInstantOfferCalculator /></HeaderLayout>} />
        <Route path="/cash-offer-calculator" element={<HeaderLayout><CashOfferCalculator /></HeaderLayout>} />



        <Route>
          <Route path="/claim/:token" element={<ClaimLead />} />
        </Route>
        {/* <Route path="/voicemails" element={<HeaderLayout><VoicemailDashboard /></HeaderLayout>} />
        <Route path="/voicemail-drops" element={<HeaderLayout><VoicemailDropDashboard /></HeaderLayout>} /> */}
        {/* <Route >
          <Route path="/doc" element={<Document />} />
        </Route>
        <Route >
          <Route path="/doc2" element={<Document2 />} />
        </Route>
        <Route >
          <Route path="/testing" element={<Testing />} />
        </Route> */}

        {/* Private */}
        <Route element={<PrivateRoute />}>
          <Route element={<PrivateRoute permission="notifications" />}>
            <Route path="/notifications" element={<HeaderLayout><NotificationsPage /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/stats" element={<HeaderLayout><Stats /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/stats-2" element={<HeaderLayout><Stats2 /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/dm-stats" element={<HeaderLayout><LeadsStat /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="agent-links" />}>
            <Route path="/agent-links" element={<HeaderLayout><Home /></HeaderLayout>} />
          </Route>
          {/* <Route element={<PrivateRoute permission="agent-links" />}>
            <Route path="/marketplace" element={<HeaderLayout><Marketplace /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="agent-links" />}>
            <Route path="/marketplace/location/:locationId" element={<HeaderLayout><Marketplace /></HeaderLayout>} />
          </Route> */}
          {/* <Route element={<PrivateRoute permission="property-search" />}> */}
          <Route path="/" element={<HeaderLayout><PropertySearch /></HeaderLayout>} />
          {/* </Route> */}
          {/* <Route element={<PrivateRoute permission="leads" />}>
              <Route path="/leads" element={<HeaderLayout><Leads /></HeaderLayout>} />
            </Route> */}
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/added-leads" element={<HeaderLayout>
              <ScrollTop /><AddedLeads /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/wrong-phones" element={<HeaderLayout>
              <ScrollTop /><WrongPhones /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/compairables" element={<HeaderLayout>
              <ScrollTop /><Compairables /></HeaderLayout>} />
          </Route>
          {/* <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/mailing-details" element={<HeaderLayout>
              <ScrollTop /><MailingDetails /></HeaderLayout>} />
          </Route> */}
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/flipped-properties" element={<HeaderLayout>
              <ScrollTop /><FlippedProperties /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeads /></HeaderLayout>} />
          </Route>
          {/* <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-s" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsS /></HeaderLayout>} />
          </Route> */}
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-g" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsG /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-t" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsT /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-m" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsM /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-b" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsB /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-d" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsD /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="leads" />}>
            <Route path="/not-added-leads-other" element={<HeaderLayout>
              <ScrollTop /><NotAddedLeadsOther /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="fetched-leads" />}>
            <Route path="/fetched-leads" element={<HeaderLayout>
              <ScrollTop /><FoundLeads /></HeaderLayout>} />
          </Route>
          {/* <Route element={<PrivateRoute permission="not-found-list-1" />}>
            <Route path="/not-found-s" element={<HeaderLayout>
              <ScrollTop /><NotFoundS /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-2" />}>
            <Route path="/not-found-s-2" element={<HeaderLayout>
              <ScrollTop /><NotFoundS2 /></HeaderLayout>} />
          </Route> */}
          <Route element={<PrivateRoute permission="not-found-list-1" />}>
            <Route path="/not-found-m" element={<HeaderLayout>
              <ScrollTop /><NotFoundM /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-2" />}>
            <Route path="/not-found-m-2" element={<HeaderLayout>
              <ScrollTop /><NotFoundM2 /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-1" />}>
            <Route path="/not-found-b" element={<HeaderLayout>
              <ScrollTop /><NotFoundB /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-2" />}>
            <Route path="/not-found-b-2" element={<HeaderLayout>
              <ScrollTop /><NotFoundB2 /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-1" />}>
            <Route path="/not-found-g" element={<HeaderLayout>
              <ScrollTop /><NotFoundG /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-2" />}>
            <Route path="/not-found-g-2" element={<HeaderLayout>
              <ScrollTop /><NotFoundG2 /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-1" />}>
            <Route path="/not-found-t" element={<HeaderLayout>
              <ScrollTop /><NotFoundT /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="not-found-list-2" />}>
            <Route path="/not-found-t-2" element={<HeaderLayout>
              <ScrollTop /><NotFoundT2 /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="transfer-history" />}>
            <Route path="/transfer-history" element={<HeaderLayout>
              <ScrollTop /><TransferHistory /></HeaderLayout>} />
          </Route>


          <Route element={<PrivateRoute permission="owner-links" />}>
            <Route path="/owner-links" element={<HeaderLayout><OwnerLinks /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="calculations" />}>
            <Route path="/calculations" element={<HeaderLayout><Calculation /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="calculations" />}>
            <Route path="/referrals" element={<HeaderLayout><Referrals /></HeaderLayout>} />
          </Route>
          {/* <Route element={<PrivateRoute permission="calculations" />}>
            <Route path="/referral-leads" element={<HeaderLayout><ReferralLeads /></HeaderLayout>} />
          </Route> */}
          {/* <Route element={<PrivateRoute permission="calculations" />}>
            <Route path="/agent-search" element={<HeaderLayout><AgentSearch /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="calculations" />}>
            <Route path="/add-agent" element={<HeaderLayout><AddAgentForm /></HeaderLayout>} />
          </Route> */}
          <Route element={<PrivateRoute permission="agents-list" />}>
            <Route path="/agents-list" element={<HeaderLayout><AgentsList /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="map-sheets" />}>
            <Route path="/map-sheets" element={<HeaderLayout><MapSheets /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-groups" />}>
            <Route path="/facebook-groups" element={<HeaderLayout><Facebookgroups /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-posts" />}>
            <Route path="/facebook-posts" element={<HeaderLayout><Facebookposts /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-accounts" />}>
            <Route path="/facebook-accounts" element={<HeaderLayout><Facebookaccounts /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-messages" />}>
            <Route path="/facebook-messages" element={<HeaderLayout><Facebookmessages /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="search-fb-groups" />}>
            <Route path="/search-fb-groups" element={<HeaderLayout><SearchFbGroups /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-logs" />}>
            <Route path="/facebook-logs" element={<HeaderLayout><FacebookLogs /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="facebook-import" />}>
            <Route path="/facebook-import" element={<HeaderLayout><FacebookImport /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="property-search" />}>
            <Route path="/property-search" element={<HeaderLayout><PropertySearch /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="address-sheets" />}>
            <Route path="/address-sheets" element={<HeaderLayout><HomeAddressSheet /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="ai-prompts" />}>
            <Route path="/ai-prompts" element={<HeaderLayout><Aiprompts /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="craigslist" />}>
            <Route path="/craigslist" element={<HeaderLayout><Craigslist /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="duval" />}>
            <Route path="/duval" element={<HeaderLayout><Duval /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="duval" />}>
            <Route path="/duval-new" element={<HeaderLayout><DuvalNew /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute />}>
            <Route path="/spintext" element={<NoHeaderLayout><Spintext /></NoHeaderLayout>} />
          </Route>

          <Route path="/formflow/*" element={<NoHeaderLayout><FormFlowRoutes /></NoHeaderLayout>} />

          <Route element={<PrivateRoute permission="call-logs-board" />}>
            <Route path="/call-logs-board" element={<HeaderLayout> <ScrollTop /><CallLogBoard /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="call-logs-board" />}>
            <Route path="/calls-dashboard" element={<HeaderLayout><CallsDashboard /></HeaderLayout>} />
          </Route>

          {/*<Route element={<PrivateRoute permission="call-logs-board" />}>
            <Route path="/leads-s" element={<HeaderLayout> <ScrollTop /><LeadsS /></HeaderLayout>} />
          </Route> */}

          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/staff/users" element={<HeaderLayout> <ScrollTop /><StaffUsers /></HeaderLayout>} />
          </Route>
          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/claim-leads" element={<HeaderLayout> <ScrollTop /><ClaimedLeads /></HeaderLayout>} />
          </Route>

          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/leads-tracking" element={<HeaderLayout> <LeadsTrackingDashboard /></HeaderLayout>} />
          </Route>

          <Route path="/sign/:token" element={<LegacySignRedirect />} />
          <Route path="/completed/:token" element={<LegacyCompletedRedirect />} />

          <Route element={<PrivateRoute permission="stats" />}>
            <Route path="/leads-tracking" element={<HeaderLayout> <LeadsTrackingDashboard /></HeaderLayout>} />
          </Route>

          <Route path="/*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </div>
    // </Router>
  );
}

export default App;
